import { registerOverrides } from 'core/api-middleware/mock-middleware/overrides';
import { middlewareController } from '@cast/infrastructure-api';
import { costReport } from 'core/api-middleware/mock-middleware/middlewares/cost-report';
import { dbo } from 'core/api-middleware/mock-middleware/middlewares/dbo';
import { featureFlags } from 'core/api-middleware/mock-middleware/middlewares/feature-flags';

export const activateMockMiddleware = () => {
  registerOverrides();
  middlewareController.addMiddleware('mock-middleware', {
    costReport,
    dbo,
    featureFlags,
  });
};
